import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { IconButton } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: "8px",
  position: "absolute",
  left: "0",
  top: "20px",
  zIndex: 2000,
  borderRadius: " 0 0.3rem 0.3rem 0",
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.brightenergy[100],
  "&:hover": {
    backgroundColor: theme.palette.secondary[500],
    color: theme.palette.brightenergy[300]
  }
}))

const CloseSidebarButton = ({ toggleMenu }) => {
  return (
    <StyledIconButton aria-label="close menu" onClick={toggleMenu} size="large" color="primary">
      <ChevronRightIcon />
    </StyledIconButton>
  )
}

export default CloseSidebarButton
